export class ImageReview {
  public mission_id: string;
}
